/* eslint-disable no-empty */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
import { Checkbox } from '@mui/material';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import axios from 'axios';
import { sha256 } from 'js-sha256';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import { FaPlay } from 'react-icons/fa';
import { Md360 } from "react-icons/md";
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import { sendUser } from '../../../../../../services/properties';
import { formatarDataEntrega, MaskPhone, NumeroFormatado, toPrice } from '../../../../../../utils/FunctionsGlobals';

import { Swiper, SwiperSlide } from 'swiper/react';

// utils
import { BsEyeFill } from 'react-icons/bs';
import HistoryComponent from '../../../../../../components/history/HistoryComponent';
import { trackLead } from '../../../../../../components/whatsAppButton/WhatsAppButton';
import Botoes from '../botoes/Botoes';
import Compartilhar from '../botoes/Compartilhar';
import styles from './GalleryPiecesProperties.module.css';

const GalleryPiecesProperties3: React.FC<{

    gallery: Array<any>;
    site: any;
    detailsProperties: any;
    orderGallery: any;
    setOrderGallery: any;
    setZoomPhoto: any;
    origin?: any;
    codsite?: any;
    setOpenMapa?: any;
    setOpenStreet?: any;
    setOpenOption?: any;
    openOption?: any;
    favorito?: any;
    setFavorito?: any;
    managerActual?: any;
}> = ({
    gallery,
    site,
    detailsProperties,
    orderGallery,
    setOrderGallery,
    origin,
    codsite,
    setOpenMapa,
    setOpenStreet,
    setZoomPhoto,
    setOpenOption,
    openOption,
    favorito,
    setFavorito,
    managerActual
}) => {
    // useState
    const router = useRouter();
    const { utm_campaign } = router.query;
    const { utm_source } = router.query;
    const { utm_medium } = router.query;
    const { utm_id } = router.query;
    const { verFts } = router.query;
    const { verfts } = router.query;
    const { agenciador } = router.query;
    const [animationPhoto, setAnimationPhoto] = useState<number>(-1);
    const [name, setName] = useState('');
    const [telephone, setTelephone] = useState('');
    const [email, setEmail] = useState('');
    const [existUser, setExistUser] = useState<any>(null);
    const [acceptPolitic, setAcceptPolitic] = useState(false);
    const [processando, setProcessando] = useState(false);
    const [interesse, setInteresse] = useState<any>(site?.transacoes[0]);
    const stylo: React.CSSProperties = {
        '--swiper-navigation-color': site?.cor2 || 'gray',
        '--swiper-pagination-color': site?.cor2 || 'gray',
    } as React.CSSProperties;
    // const [active, setActive] = useState(false);

    const selectTransacao = async () => {
        if(interesse == "Venda"){
            setInteresse("Aluguel")
        } else {
            setInteresse("Venda")
        }
    }

    const initialFlow: any = [
        'home',
        'imóveis', `${router.query.model || "-"}`,`${router.query.city || "-"}`,`${router.query.district || "-"}`,`${site?.exibir_empreendimento ? router.query.company || "-" : '-'}`,`${router.query.type || "-"}`,`${router.query.code || "-"}`
    ];

    const calcularTotal = (precoLocacao?: number, precoCondominio?: number, precoIptu?: number): number => {
        const locacao = precoLocacao || 0;
        const condominio = precoCondominio || 0;
        const iptu = precoIptu || 0;

        return locacao + condominio + iptu;
    };

    useEffect(() => {
        try {
            const getUser: any = localStorage.getItem('user');
            setExistUser(JSON.parse(getUser || ''));
        } catch (error) {}
    }, []);

    useEffect(() => {
        if (gallery?.length > 0 && site?.id && detailsProperties?.id) {
            const validationOrderGallery = gallery
            const validationGallery =
                existUser || verFts === "1" || verfts == '1' ||
                (detailsProperties?.aluguel > 0
                        ? Number(site?.libera_fts_aluguel)
                        : (!Number(site?.bloquear_fotos) && !detailsProperties?.bloquear_fotos))
                    ? validationOrderGallery
                    : validationOrderGallery?.slice(
                          0,
                          site?.qtd_fotos_bloqueios
                      );
            if (
                existUser || verFts === "1" || verfts === '1' ||
                (detailsProperties?.aluguel > 0
                        ? Number(site?.libera_fts_aluguel)
                        : (!Number(site?.bloquear_fotos) && (!Number(detailsProperties?.bloquear_fotos == true))))
            ) {
                if (detailsProperties?.link_video && detailsProperties?.tour360 && ((detailsProperties?.link_video != 'https://youtu.be/EngkU-Vcp2Q' && detailsProperties?.link_video != "https://www.youtube.com/watch?v=EngkU-Vcp2Q&feature=youtu.be") || site?.id != '2059')) {
                    const video = detailsProperties?.link_video.replaceAll("https://www.youtube.com/watch?v=","").replace("https://youtu.be/","").split("&")
                    setOrderGallery([

                        {
                            id: 'tour360',
                            video: detailsProperties?.tour360
                        }
                        ,
                        {
                            id: 'video',
                            video: video[0]
                                ?.split('/')
                                ?.slice(-1)[0],
                        },
                        ...validationGallery,

                    ]);
                } else {
                    if (detailsProperties?.link_video && ((detailsProperties?.link_video != 'https://youtu.be/EngkU-Vcp2Q' && detailsProperties?.link_video != "https://www.youtube.com/watch?v=EngkU-Vcp2Q&feature=youtu.be") || site?.id != '2059')) {
                        const video = detailsProperties?.link_video.replaceAll("https://www.youtube.com/watch?v=","").replace("https://youtu.be/","").split("&")
                        setOrderGallery([
                            {
                                id: 'video',
                                video: video[0]
                                    ?.split('/')
                                    ?.slice(-1)[0],
                            },
                            ...validationGallery,

                        ]);
                    }else {
                        if (detailsProperties?.tour360) {
                        setOrderGallery([
                            {
                                id: 'tour360',
                                video: detailsProperties?.tour360
                            },
                            ...validationGallery,

                        ]);
                        }else{
                            setOrderGallery(validationGallery);
                        }
                    }
                }
            } else {
                if (detailsProperties?.link_video && detailsProperties?.tour360 && ((detailsProperties?.link_video != 'https://youtu.be/EngkU-Vcp2Q' && detailsProperties?.link_video != "https://www.youtube.com/watch?v=EngkU-Vcp2Q&feature=youtu.be") || site?.id != '2059')) {
                    const video = detailsProperties?.link_video.replaceAll("https://www.youtube.com/watch?v=","").replace("https://youtu.be/","").split("&")
                    setOrderGallery([
                        {
                            id: 'tour360',
                            video: detailsProperties?.tour360
                        }
                        ,
                        {
                            id: 'video',
                            video: video[0]
                                ?.split('/')
                                ?.slice(-1)[0],
                        },
                        ...validationGallery, { id: 'bloquear' }

                    ]);
                } else {
                    if (detailsProperties?.tour360) {
                        setOrderGallery([
                            {
                                id: 'tour360',
                                video: detailsProperties?.tour360
                            },
                            ...validationGallery, { id: 'bloquear' }
                        ]);
                    }else{
                        if (detailsProperties?.link_video && ((detailsProperties?.link_video != 'https://youtu.be/EngkU-Vcp2Q' && detailsProperties?.link_video != "https://www.youtube.com/watch?v=EngkU-Vcp2Q&feature=youtu.be") || site?.id != '2059')) {
                            const video = detailsProperties?.link_video.replaceAll("https://www.youtube.com/watch?v=","").replace("https://youtu.be/","").split("&")
                            setOrderGallery([
                                {
                                    id: 'video',
                                    video: video[0]
                                        ?.split('/')
                                        ?.slice(-1)[0],
                                },
                                ...validationGallery,{ id: 'bloquear' }

                            ]);
                        } else {
                            setOrderGallery([...validationGallery, { id: 'bloquear' }]);
                        }
                    }
                }
            }
        }
    }, [gallery, site, detailsProperties, existUser]);

    // methods
    const onChangeName = (txt: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = txt.target;
        setName(value);
    };

    // const openForm = () => {
    //     setActive(true);
    // };

    const onChangeTelephone = (txt: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = txt.target;
        const formatTelephone = MaskPhone(value);
        setTelephone(formatTelephone);
    };
    const onChangeEmail = (txt: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = txt.target;
        setEmail(value);
    };

    function isPhoneNumberValid(phoneNumber: string): boolean {
        // Remove todos os caracteres não numéricos
        const cleanedNumber = phoneNumber.replace(/\D/g, '');

        // Verifica se todos os caracteres são iguais
        const allEqual = new Set(cleanedNumber).size === 1;

        // Retorna true se não forem todos iguais
        return !allEqual;
    }

    const validaSendUser = async () => {
        if (name != '' && email != '' && telephone != '') {
            const phone = telephone.replace(/[^0-9]/g, '');
            const valida = isPhoneNumberValid(phone)
            var re = /\S+@\S+\.\S+/;
            if (phone.length > 9 && phone.length < 12 && valida) {
                if (re.test(email) == true) {
                    if(acceptPolitic && !processando){
                        if(!processando){
                            setProcessando(true);
                            actionSendUser();
                        }
                    }else {
                        alert('Concorde com os termos de uso!');
                    }
                } else {
                    alert('Preencha um email válido!');
                }
            } else {
                alert('Preencha um número de telefone válido!');
            }
        } else {
            alert(
                'Preencha todos os campos do formulário para ver mais fotos!'
            );
        }
    };
    const actionSendUser = async () => {
        const getSendUser = await sendUser(
            JSON.stringify(utm_campaign),
            JSON.stringify(utm_source),
            JSON.stringify(utm_medium),
            JSON.stringify(utm_id),
            JSON.stringify("Solicitou ver mais fotos do imóvel " + detailsProperties?.id),
            JSON.stringify(name),
            JSON.stringify(email),
            JSON.stringify(telephone),
            detailsProperties?.id,
            agenciador != undefined ? Number(agenciador) : 0,
            origin,
            codsite,
            interesse ? interesse : ""
        );
        localStorage.setItem(
            'user',
            JSON.stringify({
                name,
                email,
                telephone,
                id_client: getSendUser?.atendimento?.id_cliente,
            })
        );
        const user = {
            name,
            telephone,
            email,
        };
        localStorage.setItem('user', JSON.stringify(user));
        setExistUser(user)
        // window.location.reload();
        if (!router.asPath.includes("enviar=1")) {
            const newUrl = router.asPath.includes("?")
                ? `${router.asPath}&enviar=1`
                : `${router.asPath}?enviar=1`;

            window.history.replaceState(null, '', newUrl);
        }
        setProcessando(false);

        if (site?.tag_google_head) {
            const scriptGa = site?.tag_google_head.match(/gtag\('config'(.*?);/g) || site?.tag_google_head.match(/ga\('create'(.*?);/g) || [];
            const googleAnalytcs = (scriptGa[0] || '')?.split("', '");
            const TRACKING_ID = (googleAnalytcs[1] || '')?.replace("');", '');

            // Google Analytics
            if(TRACKING_ID){
                const eventData = {
                    formData: {
                        name: name,
                        email: email,
                        telefone: telephone,
                        id_client: getSendUser?.atendimento?.id_cliente,
                    },
                    propertyInfo: {
                        url: 'https://'+site?.site,
                        referencia: detailsProperties?.referencia,
                        id: detailsProperties?.id,
                        preco: detailsProperties?.preco,
                        preco_loca: detailsProperties?.preco_loca,
                        tipo: detailsProperties?.tipo?.nome,
                        empreendimento: detailsProperties?.empreendimento?.nome,
                        cidade: detailsProperties?.cidade?.nome,
                        bairro: detailsProperties?.bairro?.nome,
                        venda: detailsProperties?.venda,
                        aluguel: detailsProperties?.aluguel
                    }
                };

                // Envie o evento para o Google Analytics com informações do imóvel
                ReactGA.send({
                    hitType: 'event',
                    eventCategory: `Solicitou ver mais fotos do imóvel ${detailsProperties?.referencia}`,
                    eventAction: 'ver_fotos',
                    eventLabel: JSON.stringify(eventData), // Convertendo as informações em JSON para enviar
                });
            }
        }

        const getCookie = (name: string) =>
            document.cookie
            .split('; ')
            .find((row) => row.startsWith(name + '='))
        ?.split('=')[1] || ''

        if (site?.fb_token_pixel && site?.fb_id_pixel && getSendUser?.atendimento?.id_cliente) {
            const accessToken = site?.fb_token_pixel;
            const pixelId = site?.fb_id_pixel;
            const currentTimestampInSeconds = Math.floor(Date.now() / 1000);

            // Normalização dos dados
            const normalizedName = name.trim().toLowerCase();
            const normalizedEmail = email.trim().toLowerCase();
            const normalizedPhone = telephone.replace(/\D/g, ''); // Apenas números

            // Hash dos dados
            const hashNome = sha256(normalizedName);
            const hashEmail = sha256(normalizedEmail);
            const hashTelefone = sha256(normalizedPhone);

            const fbc = getCookie('_fbc')
            const fbp = getCookie('_fbp')

            let clientIpAddress: string
            try {
                const res6 = await axios.get<{ ip: string }>(
                'https://api6.ipify.org?format=json'
                )
                clientIpAddress = res6.data.ip
            } catch {
                const res4 = await axios.get<{ ip: string }>(
                'https://api.ipify.org?format=json'
                )
                clientIpAddress = res4.data.ip
            }

            // Dados do evento
            const eventData = [
                {
                event_name: 'Lead',
                event_time: currentTimestampInSeconds,
                action_source: 'website',
                event_source_url: 'https://' + site?.site,
                user_data: {
                    fn: [hashNome],
                    em: [hashEmail],
                    ph: [hashTelefone],
                    fbc: fbc || undefined,
                    fbp: fbp || undefined,
                    client_ip_address: clientIpAddress
                }
            }];

            axios.post(
                `https://graph.facebook.com/v12.0/${pixelId}/events?access_token=${accessToken}`,
                { data: eventData }
            )
                .then(response => {
                console.log('Evento registrado com sucesso:', response.data);
                })
                .catch(error => {
                console.error('Erro ao registrar evento:', error?.response?.data || error.message);
            });
        }
    };

    const handleProgress = (progress: number) => {
        if(openOption == 0 && !existUser && verFts != "1" && verfts != '1' && ((site?.bloquear_fotos || detailsProperties?.bloquear_fotos) || (detailsProperties?.aluguel && site?.libera_fts_aluguel == 0 ? true : false))){
            if (progress >= 0.9) {
                setOpenOption(1);
            }
        }
    };

    return (
            <>
                <div className={styles.container_fora}>
                    <div className={styles.container0}>
                        <div>
                            <div style={{display: "flex"}}>
                                <div
                                    className={styles.codigoImovel}
                                >
                                    {`Código: ${detailsProperties?.referencia}`}
                                </div>
                                {detailsProperties?.exclu ?
                                    <div
                                        className={styles.imovel_exclusivo}
                                    >
                                        Imóvel Exclusivo
                                    </div>
                                : null}
                                {detailsProperties?.visualizacoes ? (
                                    <div className={styles.subtitle_view}>
                                        {(detailsProperties?.visualizacoes > 99 || site?.id == "1694" || site?.id == "1665" ) && site?.mostrar_visualizacoes ?
                                            <>
                                                <div
                                                    className={styles.imovel_exclusivo} style={{padding: "0px 10px"}}
                                                >
                                                     <BsEyeFill
                                                        size={18}
                                                        color="#6ba94f"
                                                        style={{ marginRight: 5 }}
                                                    />
                                                   {detailsProperties?.visualizacoes + ' Visualizações'}
                                                </div>
                                            </>
                                        :null}
                                    </div>
                            ) : null}
                            </div>

                            {formatarDataEntrega(Number(detailsProperties?.data_entrega)) != "false" && detailsProperties?.data_entrega && site?.mostrar_data_entrega ?
                                <label className={styles.subtitle1} style={{margin: "5px 0px"}}>
                                    Entrega em {formatarDataEntrega(Number(detailsProperties?.data_entrega))}
                                </label>
                            : null}
                            {detailsProperties?.titulo && !site?.titulo_automatico ?
                                <h1 className={styles.adjust_font_size}>
                                    {detailsProperties?.titulo}
                                </h1>
                                :
                                <h1 className={styles.adjust_font_size}>
                                    {detailsProperties?.tipo?.nome}{' '}
                                    {detailsProperties?.area_privativa > 0 ? " com "+NumeroFormatado(Number(detailsProperties?.area_privativa)) + " m² privativos, " :
                                    detailsProperties?.area_total > 0 ? " com "+NumeroFormatado(Number(detailsProperties?.area_total)) + " m² de área total, " :
                                    detailsProperties?.terreno > 0 ? " com "+NumeroFormatado(Number(detailsProperties?.terreno)) + " m² de área terreno, " : ""}
                                    {detailsProperties?.dormitorios > 0 ? detailsProperties?.dormitorios > 1 ? detailsProperties?.dormitorios +" dormitórios " : "1 dormitório " : ""}
                                    {detailsProperties?.suites > 0 ? detailsProperties?.suites > 1 ? "e "+detailsProperties?.suites +" suítes " : "e 1 suíte " : ""}
                                    {"em "+detailsProperties?.cidade?.nome}
                                    {`${detailsProperties?.empreendimento?.nome && site?.exibir_empreendimento ? " - "+detailsProperties?.empreendimento?.nome : ''}`}
                                </h1>}
                            {detailsProperties?.mostrar_endereco && detailsProperties?.endereco && !site?.ocultar_endereco ?
                                <label className={styles.subtitle1} style={{marginBottom: 20}}>
                                    {`${detailsProperties?.endereco}, ${detailsProperties?.bairro?.nome} - ${detailsProperties?.cidade?.nome}`}
                                </label>
                            : null}
                        </div>

                        <div>
                            <div>
                                {detailsProperties?.venda ?
                                    Number(
                                        detailsProperties?.exibir_preco_venda &&
                                            detailsProperties?.preco_venda
                                    ) ? (
                                        <div
                                            className={detailsProperties?.preco_especial?.preco_especial_venda ? styles.text_price_oferta : styles.text_price}
                                        >
                                            {`Venda: ${site?.moeda_tipo}`}
                                            <label style={detailsProperties?.preco_especial?.preco_especial_venda ? {textDecoration: "line-through",marginLeft: 5} : {marginLeft: 5}}>
                                                {`${toPrice(
                                                    detailsProperties?.preco_venda,
                                                    2
                                                )}`}
                                            </label>
                                        </div>
                                    ) : <label
                                            className={
                                                detailsProperties?.preco_especial
                                                    ?.preco_especial_venda
                                                    ? styles.text_price_oferta
                                                    : styles.text_price
                                            }
                                        >
                                            {`Venda: Valor sob Consulta`}
                                        </label> : null}
                                {detailsProperties?.venda ?
                                    detailsProperties?.preco_especial?.preco_especial_venda &&
                                        detailsProperties?.exibir_preco_venda &&
                                        detailsProperties?.preco_venda ? (
                                        <label className={styles.text_price}>
                                            {`Por: ${site?.moeda_tipo} ${toPrice(
                                                detailsProperties?.preco_especial
                                                    ?.preco_especial_venda,
                                                2
                                            )}`}
                                        </label>
                                    ) : null
                                    :null
                                }
                            </div>

                            <div>
                                {Number(
                                    detailsProperties?.exibir_preco_locacao &&
                                        detailsProperties?.preco_locacao
                                ) ? (
                                    <div
                                        className={
                                            detailsProperties?.preco_especial
                                                ?.preco_especial_locacao
                                                ? styles.text_price_oferta
                                                : styles.text_price
                                        }
                                    >
                                        {`Aluguel: ${site?.moeda_tipo}`}
                                            <label style={detailsProperties?.preco_especial?.preco_especial_locacao ? {textDecoration: "line-through",marginLeft: 5} : {marginLeft: 5}}>
                                                {`${toPrice(
                                                    detailsProperties?.preco_locacao,
                                                    2
                                                )}`}
                                            </label>
                                    </div>
                                ) : null}

                                {detailsProperties?.preco_especial
                                    ?.preco_especial_locacao &&
                                detailsProperties?.exibir_preco_locacao &&
                                detailsProperties?.preco_locacao ? (
                                    <label className={styles.text_price}>
                                        {`Por: ${site?.moeda_tipo} ${toPrice(
                                            detailsProperties?.preco_especial
                                                ?.preco_especial_locacao,
                                            2
                                        )}`}
                                    </label>
                                ) : null}
                            </div>

                            { detailsProperties?.temporada && detailsProperties?.d1 > 0
                                ? (
                                    <label
                                        className={
                                            styles.text_price
                                        }
                                        style={{marginTop: 20}}
                                    >
                                        {site?.id != '1667' ?
                                            <>
                                        {`Diária: ${site?.moeda_tipo} ${toPrice(
                                            detailsProperties?.d1,
                                            2
                                        )}`}
                                        </>
                                        : <>Diária: Sob Consulta</>}
                                    </label>
                            ) :
                                <>
                                    {detailsProperties?.exibir_preco_iptu &&
                                        detailsProperties?.preco_iptu > 0 ? (
                                            <label className={styles.text_price_oferta1}>{`IPTU: ${site?.moeda_tipo} ${toPrice(
                                                detailsProperties?.preco_iptu,
                                                2
                                            )}`}</label>
                                        ) : null}
                                        {detailsProperties?.exibir_preco_condominio &&
                                        detailsProperties?.preco_condominio > 0 ? (
                                            <label className={styles.text_price_oferta1}>{`CONDOMÍNIO: ${site?.moeda_tipo} ${toPrice(
                                                detailsProperties?.preco_condominio,
                                                2
                                            )}`}</label>
                                        ) : null
                                    }
                                    {detailsProperties?.aluguel && (detailsProperties?.preco_especial?.preco_especial_locacao > 0 || detailsProperties?.preco_locacao > 0) && site?.id == 747 && (detailsProperties?.exibir_preco_locacao && detailsProperties?.preco_locacao) && ((detailsProperties?.exibir_preco_condominio && detailsProperties?.preco_condominio) || (detailsProperties?.exibir_preco_iptu && detailsProperties?.preco_iptu > 0)) ?
                                        <label className={styles.text_price_oferta1} style={{fontWeight: 'bold', fontSize: 24}}>
                                            {`Total: ${site?.moeda_tipo} ${toPrice(calcularTotal(
                                                detailsProperties?.preco_especial?.preco_especial_locacao ? Number(detailsProperties?.preco_especial?.preco_especial_locacao) : Number(detailsProperties?.preco_locacao),
                                                detailsProperties?.exibir_preco_condominio ? Number(detailsProperties?.preco_condominio) || 0 : 0,
                                                detailsProperties?.exibir_preco_iptu ? Number(detailsProperties?.preco_iptu) || 0 : 0
                                            ),2)}`}
                                        </label>
                                        : null
                                    }
                                </>
                            }
                            <div className={styles.botoes_captacao}>
                            {site?.id == 1859 ?
                            <a
                                href={site?.id == 1945 ? "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0_4-BSJuo81pw6pAqA4YX4UyBySYbsfwWwoGUflArIMDI1EMOGJOlB2thFm8cRRFQXI78ioUdI" : site?.id == "1937" ? `https://api.whatsapp.com/send?phone=5${
                                            (managerActual?.id)
                                                ? (
                                                    managerActual?.telefone ||
                                                    managerActual?.telefone_2
                                                )?.replace(/\D/g, '')
                                                : (site?.Dados?.tel1 || site?.Dados?.tel2)?.replace(
                                                    /\D/g,
                                                    ''
                                                )
                                        }&text=Olá, quero agendar uma visita ao imóvel Link: ${
                                            typeof window !== 'undefined' && window.location.origin
                                        }${
                                            typeof window !== 'undefined' &&
                                            window.location.pathname
                                        }` : `https://api.whatsapp.com/send?phone=55${
                                            (managerActual?.id)
                                                ? (
                                                    managerActual?.telefone ||
                                                    managerActual?.telefone_2
                                                )?.replace(/\D/g, '')
                                                : (site?.Dados?.tel1 || site?.Dados?.tel2)?.replace(
                                                    /\D/g,
                                                    ''
                                                )
                                        }&text=${site?.id == 1859 ? "Olá, estou acessando o imóvel no site e gostaria de mais informações:" : "Olá, quero agendar uma visita ao imóvel Link:"} ${
                                            typeof window !== 'undefined' && window.location.origin
                                        }${
                                            typeof window !== 'undefined' &&
                                            window.location.pathname
                                        }`}
                                onClick={async (e) => {
                                    e.preventDefault(); // Evita o redirecionamento automático

                                    trackLead(site, detailsProperties); // 🔥 Registra o evento Lead

                                    // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                    setTimeout(() => {
                                    window.open(
                                        site?.id == 1945 ? "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0_4-BSJuo81pw6pAqA4YX4UyBySYbsfwWwoGUflArIMDI1EMOGJOlB2thFm8cRRFQXI78ioUdI" : site?.id == "1937" ? `https://api.whatsapp.com/send?phone=5${
                                            (managerActual?.id)
                                                ? (
                                                    managerActual?.telefone ||
                                                    managerActual?.telefone_2
                                                )?.replace(/\D/g, '')
                                                : (site?.Dados?.tel1 || site?.Dados?.tel2)?.replace(
                                                    /\D/g,
                                                    ''
                                                )
                                        }&text=Olá, quero agendar uma visita ao imóvel Link: ${
                                            typeof window !== 'undefined' && window.location.origin
                                        }${
                                            typeof window !== 'undefined' &&
                                            window.location.pathname
                                        }` : `https://api.whatsapp.com/send?phone=55${
                                            (managerActual?.id)
                                                ? (
                                                    managerActual?.telefone ||
                                                    managerActual?.telefone_2
                                                )?.replace(/\D/g, '')
                                                : (site?.Dados?.tel1 || site?.Dados?.tel2)?.replace(
                                                    /\D/g,
                                                    ''
                                                )
                                        }&text=${site?.id == 1859 ? "Olá, estou acessando o imóvel no site e gostaria de mais informações:" : "Olá, quero agendar uma visita ao imóvel Link:"} ${
                                            typeof window !== 'undefined' && window.location.origin
                                        }${
                                            typeof window !== 'undefined' &&
                                            window.location.pathname
                                        }`,
                                        "_blank"
                                    );
                                    }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                }}
                                rel="noopener noreferrer"
                                className={styles.botao_visita}
                                title="Agendar uma visita para este imóvel via WhatsApp"
                                aria-label="Agendar uma visita para este imóvel via WhatsApp"
                            >
                                Saiba Mais
                            </a>: null}
                                <a
                                    rel="noopener noreferrer"
                                    href={site?.id == 1945 ? "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0_4-BSJuo81pw6pAqA4YX4UyBySYbsfwWwoGUflArIMDI1EMOGJOlB2thFm8cRRFQXI78ioUdI" : site?.id == "1937" ? `https://api.whatsapp.com/send?phone=5${
                                                (managerActual?.id)
                                                    ? (
                                                        managerActual?.telefone ||
                                                        managerActual?.telefone_2
                                                    )?.replace(/\D/g, '')
                                                    : (site?.Dados?.tel1 || site?.Dados?.tel2)?.replace(
                                                        /\D/g,
                                                        ''
                                                    )
                                            }&text=Olá, quero agendar uma visita ao imóvel Link: ${
                                                typeof window !== 'undefined' && window.location.origin
                                            }${
                                                typeof window !== 'undefined' &&
                                                window.location.pathname
                                            }` : `https://api.whatsapp.com/send?phone=55${
                                                (managerActual?.id)
                                                    ? (
                                                        managerActual?.telefone ||
                                                        managerActual?.telefone_2
                                                    )?.replace(/\D/g, '')
                                                    : (site?.Dados?.tel1 || site?.Dados?.tel2)?.replace(
                                                        /\D/g,
                                                        ''
                                                    )
                                            }&text=Olá, quero agendar uma visita ao imóvel Link: ${
                                                typeof window !== 'undefined' && window.location.origin
                                            }${
                                                typeof window !== 'undefined' &&
                                                window.location.pathname
                                            }`}
                                    onClick={async (e) => {
                                        e.preventDefault(); // Evita o redirecionamento automático

                                        trackLead(site, detailsProperties); // 🔥 Registra o evento Lead

                                        // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                        setTimeout(() => {
                                        window.open(
                                            site?.id == 1945 ? "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0_4-BSJuo81pw6pAqA4YX4UyBySYbsfwWwoGUflArIMDI1EMOGJOlB2thFm8cRRFQXI78ioUdI" : site?.id == "1937" ? `https://api.whatsapp.com/send?phone=5${
                                                (managerActual?.id)
                                                    ? (
                                                        managerActual?.telefone ||
                                                        managerActual?.telefone_2
                                                    )?.replace(/\D/g, '')
                                                    : (site?.Dados?.tel1 || site?.Dados?.tel2)?.replace(
                                                        /\D/g,
                                                        ''
                                                    )
                                            }&text=Olá, quero agendar uma visita ao imóvel Link: ${
                                                typeof window !== 'undefined' && window.location.origin
                                            }${
                                                typeof window !== 'undefined' &&
                                                window.location.pathname
                                            }` : `https://api.whatsapp.com/send?phone=55${
                                                (managerActual?.id)
                                                    ? (
                                                        managerActual?.telefone ||
                                                        managerActual?.telefone_2
                                                    )?.replace(/\D/g, '')
                                                    : (site?.Dados?.tel1 || site?.Dados?.tel2)?.replace(
                                                        /\D/g,
                                                        ''
                                                    )
                                            }&text=Olá, quero agendar uma visita ao imóvel Link: ${
                                                typeof window !== 'undefined' && window.location.origin
                                            }${
                                                typeof window !== 'undefined' &&
                                                window.location.pathname
                                            }`,
                                            "_blank"
                                        );
                                        }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                    }}
                                    className={site?.id == 1859 ? styles.botao_proposta : styles.botao_visita}
                                    title="Agendar uma visita para este imóvel via WhatsApp"
                                    aria-label="Agendar uma visita para este imóvel via WhatsApp"
                                >
                                    {site?.id == 2374 ? 'Chamar no WhatsApp' : 'Agendar Visita'}
                                </a>
                                {site?.id != 1859 ?
                                <a
                                    rel="noopener noreferrer"
                                    href={site?.id == 1945 ? "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0_4-BSJuo81pw6pAqA4YX4UyBySYbsfwWwoGUflArIMDI1EMOGJOlB2thFm8cRRFQXI78ioUdI" : site?.id == "1937" ? `https://api.whatsapp.com/send?phone=5${
                                                (managerActual?.id)
                                                    ? (
                                                        managerActual?.telefone ||
                                                        managerActual?.telefone_2
                                                    )?.replace(/\D/g, '')
                                                    : (site?.Dados?.tel1 || site?.Dados?.tel2)?.replace(
                                                        /\D/g,
                                                        ''
                                                    )
                                            }&text=Olá, quero agendar uma visita ao imóvel Link: ${
                                                typeof window !== 'undefined' && window.location.origin
                                            }${
                                                typeof window !== 'undefined' &&
                                                window.location.pathname
                                            }` : `https://api.whatsapp.com/send?phone=55${
                                                (managerActual?.id)
                                                    ? (
                                                        managerActual?.telefone ||
                                                        managerActual?.telefone_2
                                                    )?.replace(/\D/g, '')
                                                    : (site?.Dados?.tel1 || site?.Dados?.tel2)?.replace(
                                                        /\D/g,
                                                        ''
                                                    )
                                            }&text=Olá, quero fazer uma proposta para o imóvel Link: ${
                                                typeof window !== 'undefined' && window.location.origin
                                            }${
                                                typeof window !== 'undefined' &&
                                                window.location.pathname
                                            }`}
                                    onClick={async (e) => {
                                        e.preventDefault(); // Evita o redirecionamento automático

                                        trackLead(site, detailsProperties); // 🔥 Registra o evento Lead

                                        // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                        setTimeout(() => {
                                        window.open(
                                            site?.id == 1945 ? "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0_4-BSJuo81pw6pAqA4YX4UyBySYbsfwWwoGUflArIMDI1EMOGJOlB2thFm8cRRFQXI78ioUdI" : site?.id == "1937" ? `https://api.whatsapp.com/send?phone=5${
                                                (managerActual?.id)
                                                    ? (
                                                        managerActual?.telefone ||
                                                        managerActual?.telefone_2
                                                    )?.replace(/\D/g, '')
                                                    : (site?.Dados?.tel1 || site?.Dados?.tel2)?.replace(
                                                        /\D/g,
                                                        ''
                                                    )
                                            }&text=Olá, quero agendar uma visita ao imóvel Link: ${
                                                typeof window !== 'undefined' && window.location.origin
                                            }${
                                                typeof window !== 'undefined' &&
                                                window.location.pathname
                                            }` : `https://api.whatsapp.com/send?phone=55${
                                                (managerActual?.id)
                                                    ? (
                                                        managerActual?.telefone ||
                                                        managerActual?.telefone_2
                                                    )?.replace(/\D/g, '')
                                                    : (site?.Dados?.tel1 || site?.Dados?.tel2)?.replace(
                                                        /\D/g,
                                                        ''
                                                    )
                                            }&text=Olá, quero fazer uma proposta para o imóvel Link: ${
                                                typeof window !== 'undefined' && window.location.origin
                                            }${
                                                typeof window !== 'undefined' &&
                                                window.location.pathname
                                            }`,
                                            "_blank"
                                        );
                                        }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                    }}
                                    title="Agendar uma visita para este imóvel via WhatsApp"
                                    aria-label="Agendar uma visita para este imóvel via WhatsApp"
                                    className={styles.botao_proposta}
                                >
                                    {site?.id == 2374 ? 'FALE COM O CORRETOR' : 'Fazer Proposta'}
                                </a>: null}
                            </div>
                        </div>
                    </div>
                    <div className={styles.container}>
                        <div className={styles.div_baloes1}>
                            <Compartilhar favorito={favorito} detailsProperties={detailsProperties}></Compartilhar>
                        </div>
                        <div className={styles.div_baloes}>
                            <Botoes
                                setOpenOption={setOpenOption}
                                site={site}
                                detailsProperties={detailsProperties}
                                setOpenMapa={setOpenMapa}
                                setOpenStreet={setOpenStreet}
                                openOption={openOption}
                                favorito={favorito}
                                setFavorito={setFavorito}
                            />
                        </div>
                        <Swiper
                            modules={[Navigation]}
                            slidesPerView="auto"
                            slidesPerGroup={1}
                            spaceBetween={10}
                            freeMode={true}
                            navigation={true}
                            className={styles.mySwiper}
                            style={stylo}
                            onProgress={(swiper: any) => handleProgress(swiper.progress)}
                        >
                        {orderGallery?.map((v: any, i: number) => {
                            const validationPhoto =
                                site?.marca_dagua?.ativada === 1 && v?.url_marca;
                            const activeAnimationPhoto = () => {
                                setAnimationPhoto(Number(v?.id));
                            };
                            if (
                                !existUser &&
                                v?.id === 'bloquear' && verFts != "1" && verfts != '1' && ((site?.bloquear_fotos || detailsProperties?.bloquear_fotos) || (detailsProperties?.aluguel && site?.libera_fts_aluguel == 0 ? true : false))
                            )  {
                                return (
                                    <SwiperSlide key="carrossel" style={{maxWidth: '100%',width: '650px'}}>
                                        <div
                                            className={styles.container_form}
                                            key={'block'+v?.id}
                                            // onMouseEnter={openForm}
                                        >
                                            {/* {active ? ( */}
                                            <div className={styles.form}>
                                                {site?.id == 1630 ?
                                                    <label className={styles.title}>
                                                        Ver mais fotos
                                                    </label>
                                                :
                                                    <>
                                                    <label className={styles.title}>
                                                        Acesso completo
                                                    </label>
                                                    <div className={styles.subtitle}>
                                                        <p
                                                            className={styles.subtitle_time}
                                                            style={{ color: "#c5c5c5" }}
                                                        >
                                                            a todo o site em 10 segundos!
                                                        </p>
                                                    </div>
                                                    </>
                                                }
                                                <input
                                                    className={styles.input}
                                                    placeholder="Nome"
                                                    value={name}
                                                    onChange={onChangeName}
                                                />
                                                <input
                                                    className={styles.input}
                                                    placeholder="Telefone"
                                                    value={telephone}
                                                    inputMode='numeric'
                                                    onChange={onChangeTelephone}
                                                />
                                                <input
                                                    className={styles.input}
                                                    placeholder="Email"
                                                    value={email}
                                                    onChange={onChangeEmail}
                                                />
                                                {detailsProperties.aluguel && detailsProperties.venda ?
                                                    <>
                                                        <label className={styles.title_form_one1}>
                                                            SELECIONE SEU INTERESSE:
                                                        </label>
                                                        <ButtonGroup disableElevation variant="contained" color="primary" style={{marginBottom: "15px"}}>
                                                            <Button onClick={selectTransacao} style={interesse == "Venda" ? site?.cor2 == "#ffffff" ? { backgroundColor: "gray", border: "1px solid gray"} : { backgroundColor: site?.cor2, border: "1px solid gray"} : { backgroundColor: "white", color: "#3d3d3d", border: "1px solid #3d3d3d" }}>Venda</Button>
                                                            <Button onClick={selectTransacao} style={interesse == "Aluguel" ? site?.cor2 == "#ffffff" ? { backgroundColor: "gray", border: "1px solid gray"} : { backgroundColor: site?.cor2, border: "1px solid gray"} : { backgroundColor: "white", color: "#3d3d3d", border: "1px solid #3d3d3d" }}>Aluguel</Button>
                                                        </ButtonGroup>
                                                    </>
                                                : null}
                                                <div className={styles.adjust_checkbox}>
                                                <Checkbox
                                                    style={{ color: 'rgb(126, 126, 126)' }}
                                                    checked={acceptPolitic}
                                                    onChange={(event, value) => setAcceptPolitic(value)}
                                                />
                                                <div className={styles.description_form}>
                                                    Ao enviar concordo com os
                                                    <Link prefetch={false} href="/termos">
                                                        <label className={styles.terms}>
                                                            termos de uso
                                                        </label>
                                                    </Link>
                                                    e
                                                    <Link prefetch={false} href="/politica">
                                                        <label className={styles.terms}>
                                                            política de privacidade,
                                                        </label>
                                                    </Link>
                                                    para contatar os próximos anunciantes e afirmo ter mais
                                                    de 18 anos
                                                </div>
                                            </div>
                                                <a
                                                    className={
                                                        acceptPolitic && name != '' && email != '' && !processando && telephone != '' && telephone.length > 13 && telephone.length < 16 && /\S+@\S+\.\S+/.test(email) == true
                                                            ? styles.button_more_photo
                                                            : styles.action_more_disabled
                                                    }
                                                    onClick={validaSendUser}
                                                >
                                                {detailsProperties?.link_video && ((detailsProperties?.link_video != 'https://youtu.be/EngkU-Vcp2Q' && detailsProperties?.link_video != "https://www.youtube.com/watch?v=EngkU-Vcp2Q&feature=youtu.be") || site?.id != '2059') ? site?.id == 1630 ? 'Acessar Agora' : 'Ver fotos' : site?.id == 1630 ? 'Acessar Agora' : 'Ver fotos'}
                                                </a>
                                            </div>
                                            {/* ) : (
                                                <label className={styles.welcome}>
                                                    Carregar + fotos
                                                </label>
                                            )} */}
                                        </div>
                                    </SwiperSlide>
                                );
                            }

                            if ((detailsProperties?.link_video && ((detailsProperties?.link_video != 'https://youtu.be/EngkU-Vcp2Q' && detailsProperties?.link_video != "https://www.youtube.com/watch?v=EngkU-Vcp2Q&feature=youtu.be") || site?.id != '2059') && ((i===0 && !detailsProperties?.tour360) || (detailsProperties?.link_video && i===1 && detailsProperties?.tour360)))) {
                                const getFirstPhoto = orderGallery?.find(
                                    (e: any) => e?.url_foto
                                );

                                return (
                                    <SwiperSlide key="carrossel1" style={{ maxWidth: '100%', width: '650px' }}>
                                        <div
                                            onClick={() => setOpenOption(3)}
                                            key={'galeria'+v?.id}
                                            className={styles.container_img}
                                        >
                                            <img
                                                src={
                                                    site?.marca_dagua?.ativada === 1 &&
                                                    getFirstPhoto?.url_marca
                                                        ? getFirstPhoto?.url_marca
                                                        : getFirstPhoto?.url_foto
                                                }
                                                alt="Vídeo do imóvel"
                                                className={styles.img}
                                            />
                                            <div className={styles.background_animation1}>
                                                <FaPlay size={100} color="white" />
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                );
                            } else {
                                if(v?.id === 'tour360'){
                                    if(v?.video.includes("youtu")){
                                        const video = v?.video.replaceAll("https://www.youtube.com/watch?v=","").replace("https://youtu.be/","").split("?")[0];
                                        const urlThumbnail = `https://img.youtube.com/vi/${video}/maxresdefault.jpg`; // URL da thumbnail

                                        return (
                                            <SwiperSlide key="carrossel2" style={{ maxWidth: '100%', width: '650px' }}>
                                                <div
                                                    onClick={() => setOpenOption(4)}
                                                    key={'tour' + v?.id}
                                                    className={styles.container_img}
                                                >
                                                    <img
                                                        src={urlThumbnail} // Exibe a thumbnail do vídeo
                                                        alt="Tour do imóvel"
                                                        className={styles.img}
                                                    />
                                                    <div className={styles.background_animation1}>
                                                        <Md360 size={100} color="white" />
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                        );
                                    }

                                    return (
                                        <SwiperSlide key="carrossel3" style={{maxWidth: '100%',width: '650px'}}>
                                            <div
                                                onClick={() => setOpenOption(4)}
                                                key={'tour'+v?.id}
                                                className={styles.container_img}
                                            >
                                                <iframe className={styles.img} id="tour-360" src={v?.video}></iframe>
                                                <div className={styles.background_animation1}>
                                                    <Md360 size={100} color="white" />
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    );
                                }
                            }
                            return v?.url_foto ? (
                                <SwiperSlide key={v?.id} style={{maxWidth: '100%',width: '650px'}}>
                                    <div
                                        onMouseEnter={activeAnimationPhoto}
                                        onClick={() => setOpenOption(1)}
                                        key={'close'+v?.id}
                                        className={styles.container_img}
                                    >
                                        <img
                                            src={validationPhoto ? v?.url_marca : v?.url_foto}
                                            className={styles.img}
                                            alt="Foto do imóvel"
                                        />
                                        {animationPhoto === Number(v?.id) ? (
                                            <div className={styles.background_animation}></div>
                                        ) : null}
                                    </div>
                                </SwiperSlide>
                            ) : null;
                        })}
                    </Swiper>
                </div>
                <div className={styles.container00}>
                    <div
                        className={styles.codigoImovel}
                    >
                        {`Código: ${detailsProperties?.referencia}`}
                    </div>
                    {detailsProperties?.titulo && !site?.titulo_automatico ?
                        <h1 className={styles.adjust_font_size}>
                            {detailsProperties?.titulo}
                        </h1>
                        :
                        <h1 className={styles.adjust_font_size}>
                            {detailsProperties?.tipo?.nome}{' '}
                            {detailsProperties?.area_privativa > 0 ? " com "+NumeroFormatado(Number(detailsProperties?.area_privativa)) + " m² privativos, " :
                            detailsProperties?.area_total > 0 ? " com "+NumeroFormatado(Number(detailsProperties?.area_total)) + " m² de área total, " :
                            detailsProperties?.terreno > 0 ? " com "+NumeroFormatado(Number(detailsProperties?.terreno)) + " m² de área terreno, " : null}
                            {detailsProperties?.dormitorios > 0 ? detailsProperties?.dormitorios > 1 ? detailsProperties?.dormitorios +" dormitórios " : "1 dormitório " : null}
                            {detailsProperties?.suites > 0 ? detailsProperties?.suites > 1 ? "e "+detailsProperties?.suites +" suítes " : "e 1 suíte " : null}
                            {"em "+detailsProperties?.cidade?.nome}
                            {`${detailsProperties?.empreendimento?.nome && site?.exibir_empreendimento ? " - "+detailsProperties?.empreendimento?.nome : ''}`}
                        </h1>}
                    {detailsProperties?.mostrar_endereco && detailsProperties?.endereco && !site?.ocultar_endereco ?
                        <label className={styles.subtitle1} style={{marginBottom: 20}}>
                            {`${detailsProperties?.endereco}, ${detailsProperties?.bairro?.nome} - ${detailsProperties?.cidade?.nome}`}
                        </label>
                    : null}

                    <div>
                        {detailsProperties?.venda ?
                            Number(
                                detailsProperties?.exibir_preco_venda &&
                                    detailsProperties?.preco_venda
                            ) ? (
                                <div
                                    className={detailsProperties?.preco_especial?.preco_especial_venda ? styles.text_price_oferta : styles.text_price}
                                >
                                    {`Venda: ${site?.moeda_tipo}`}
                                    <label style={detailsProperties?.preco_especial?.preco_especial_venda ? {textDecoration: "line-through",marginLeft: 5} : {marginLeft: 5}}>
                                        {`${toPrice(
                                            detailsProperties?.preco_venda,
                                            2
                                        )}`}
                                    </label>
                                </div>
                            ) : <label
                                    className={
                                        detailsProperties?.preco_especial
                                            ?.preco_especial_venda
                                            ? styles.text_price_oferta
                                            : styles.text_price
                                    }
                                >
                                    {`Venda: Valor sob Consulta`}
                                </label> : null}
                        {detailsProperties?.venda ?
                            detailsProperties?.preco_especial?.preco_especial_venda &&
                                detailsProperties?.exibir_preco_venda &&
                                detailsProperties?.preco_venda ? (
                                <label className={styles.text_price}>
                                    {`Por: ${site?.moeda_tipo} ${toPrice(
                                        detailsProperties?.preco_especial
                                            ?.preco_especial_venda,
                                        2
                                    )}`}
                                </label>
                            ) : null
                            :null
                        }
                    </div>

                    <div>
                        {Number(
                            detailsProperties?.exibir_preco_locacao &&
                                detailsProperties?.preco_locacao
                        ) ? (
                            <div
                                className={
                                    detailsProperties?.preco_especial
                                        ?.preco_especial_locacao
                                        ? styles.text_price_oferta
                                        : styles.text_price
                                }
                            >
                                {`Aluguel: ${site?.moeda_tipo}`}
                                    <label style={detailsProperties?.preco_especial?.preco_especial_locacao ? {textDecoration: "line-through",marginLeft: 5} : {marginLeft: 5}}>
                                        {`${toPrice(
                                            detailsProperties?.preco_locacao,
                                            2
                                        )}`}
                                    </label>
                            </div>
                        ) : null}

                        {detailsProperties?.preco_especial
                            ?.preco_especial_locacao &&
                        detailsProperties?.exibir_preco_locacao &&
                        detailsProperties?.preco_locacao ? (
                            <label className={styles.text_price}>
                                {`Por: ${site?.moeda_tipo} ${toPrice(
                                    detailsProperties?.preco_especial
                                        ?.preco_especial_locacao,
                                    2
                                )}`}
                            </label>
                        ) : null}
                    </div>

                    { detailsProperties?.temporada && detailsProperties?.d1 > 0
                        ? (
                            <label
                                className={
                                    styles.text_price
                                }
                                style={{marginTop: 20}}
                            >
                                {site?.id != '1667' ?
                                    <>
                                {`Diária: ${site?.moeda_tipo} ${toPrice(
                                    detailsProperties?.d1,
                                    2
                                )}`}
                                </>
                                : <>Diária: Sob Consulta</>}
                            </label>
                    ) :
                        <>
                            {detailsProperties?.exibir_preco_iptu &&
                                detailsProperties?.preco_iptu > 0 ? (
                                    <label className={styles.text_price_oferta1}>{`IPTU: ${site?.moeda_tipo} ${toPrice(
                                        detailsProperties?.preco_iptu,
                                        2
                                    )}`}</label>
                                ) : null}
                                {detailsProperties?.exibir_preco_condominio &&
                                detailsProperties?.preco_condominio > 0 ? (
                                    <label className={styles.text_price_oferta1}>{`CONDOMÍNIO: ${site?.moeda_tipo} ${toPrice(
                                        detailsProperties?.preco_condominio,
                                        2
                                    )}`}</label>
                                ) : null
                            }
                            {detailsProperties?.aluguel && (detailsProperties?.preco_especial?.preco_especial_locacao > 0 || detailsProperties?.preco_locacao > 0) && site?.id == 747 && (detailsProperties?.exibir_preco_locacao && detailsProperties?.preco_locacao) && ((detailsProperties?.exibir_preco_condominio && detailsProperties?.preco_condominio) || (detailsProperties?.exibir_preco_iptu && detailsProperties?.preco_iptu > 0)) ?
                                <label className={styles.text_price_oferta1} style={{fontWeight: 'bold', fontSize: 24}}>
                                    {`Total: ${site?.moeda_tipo} ${toPrice(calcularTotal(
                                        detailsProperties?.preco_especial?.preco_especial_locacao ? Number(detailsProperties?.preco_especial?.preco_especial_locacao) : Number(detailsProperties?.preco_locacao),
                                        detailsProperties?.exibir_preco_condominio ? Number(detailsProperties?.preco_condominio) || 0 : 0,
                                        detailsProperties?.exibir_preco_iptu ? Number(detailsProperties?.preco_iptu) || 0 : 0
                                    ),2)}`}
                                </label>
                                : null
                            }
                        </>
                    }
                </div>
            </div>
            <HistoryComponent routes={initialFlow} pagina={3}/>
        </>
    );
};

export default GalleryPiecesProperties3;
